import { render, staticRenderFns } from "./SuperAdminRolesView.vue?vue&type=template&id=01a06296&scoped=true&lang=pug"
import script from "./SuperAdminRolesView.vue?vue&type=script&lang=ts"
export * from "./SuperAdminRolesView.vue?vue&type=script&lang=ts"
import style0 from "./SuperAdminRolesView.vue?vue&type=style&index=0&id=01a06296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a06296",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VIcon,VRow})
